/** Client-side lifecycle buckets for Library status filter pills. */

export type LibraryStatusFilterId = 'all' | 'draft' | 'design' | 'analysis' | 'complete';

export interface LibraryStatusFilterOption {
  id: LibraryStatusFilterId;
  label: string;
}

export const LIBRARY_STATUS_FILTERS: LibraryStatusFilterOption[] = [
  { id: 'all', label: 'All' },
  { id: 'draft', label: 'Draft' },
  { id: 'design', label: 'Design' },
  { id: 'analysis', label: 'Analysis' },
  { id: 'complete', label: 'Complete' },
];

const STATUS_LABEL_TO_FILTER: Record<string, LibraryStatusFilterId> = {
  Draft: 'draft',
  External: 'draft',
  'Design complete': 'design',
  'In analysis': 'analysis',
  'Analysis complete': 'complete',
};

export function resolveLibraryStatusFilter(statusLabel: string): LibraryStatusFilterId {
  return STATUS_LABEL_TO_FILTER[statusLabel] ?? 'draft';
}

export function formatLibraryCardStatus(statusLabel: string): string {
  if (statusLabel === 'External') return 'DRAFT';
  if (statusLabel === 'Design complete') return 'DESIGN';
  if (statusLabel === 'In analysis') return 'ANALYSIS';
  if (statusLabel === 'Analysis complete') return 'COMPLETE';
  return statusLabel.toUpperCase();
}

export type LibrarySortOrder = 'newest' | 'oldest';

export const LIBRARY_SORT_OPTIONS: { id: LibrarySortOrder; label: string }[] = [
  { id: 'newest', label: 'Newest' },
  { id: 'oldest', label: 'Oldest' },
];
